import { render, staticRenderFns } from "./textProperty.vue?vue&type=template&id=7d48c0a2"
import script from "./textProperty.vue?vue&type=script&lang=js"
export * from "./textProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports